import { useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { photoLabel } from "@/data/portfolio";

export const WorkPhoto = ({ photo, className = "", priority = false, sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw", testId }) => {
  const { t } = useLanguage();
  const [loaded, setLoaded] = useState(false);
  return <img data-testid={testId || `work-photo-${photo.id}`} src={photo.src} srcSet={photo.srcSet} sizes={sizes}
    alt={photoLabel(photo, t)} width={photo.width} height={photo.height} loading={priority ? "eager" : "lazy"}
    fetchPriority={priority ? "high" : "auto"} decoding="async" onLoad={() => setLoaded(true)} onError={() => setLoaded(true)}
    className={`work-image ${loaded ? "is-loaded" : ""} ${className}`} />;
};